import React from 'react';
import { Zap, ArrowRight } from 'lucide-react';

const SisterServiceBanner = () => {
  // Scoped colour override: PrecisionWaterjet uses a cyan/blue accent.
  // Re-bind the --primary token for this banner only so every `*-primary`
  // utility inside renders blue while the rest of the site stays amber.
  const pwjAccent = {
    ['--primary' as string]: '190 95% 50%',
    ['--accent' as string]: '190 80% 45%',
    ['--ring' as string]: '190 95% 50%',
  } as React.CSSProperties;

  return (
    <div className="container-wide mx-auto px-4 md:px-8" style={pwjAccent}>
      <a
        href="https://www.pwj.co.nz"
        target="_blank"
        rel="noopener noreferrer"
        className="group relative block overflow-hidden rounded-2xl glass-card border border-primary/30 hover:border-primary transition-all duration-500 hover-lift"
      >
        <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

        <div className="relative flex flex-col md:flex-row items-center gap-6 px-6 md:px-10 py-6 md:py-7">
          <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-primary/10 border border-primary/30 flex items-center justify-center">
            <Zap className="w-6 h-6 text-primary" strokeWidth={2} />
          </div>

          <div className="flex-1 text-center md:text-left">
            <p className="text-primary font-medium tracking-[0.25em] uppercase text-xs mb-1">
              Also from us
            </p>
            <h3 className="font-display text-xl md:text-2xl font-bold text-foreground leading-tight">
              We also offer{' '}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-[hsl(190_95%_55%)] to-[hsl(200_90%_45%)]">
                CNC Waterjet Profile Cutting
              </span>
            </h3>
            <p className="text-muted-foreground text-sm mt-1">
              Visit{' '}
              <span className="text-primary font-medium">www.pwj.co.nz</span>{' '}
              to see what else we do.
            </p>
          </div>

          <div className="flex-shrink-0 flex items-center gap-2 text-primary font-medium text-sm whitespace-nowrap group-hover:translate-x-1 transition-transform duration-300">
            Visit Site
            <ArrowRight className="w-4 h-4" />
          </div>
        </div>
      </a>
    </div>
  );
};

export default SisterServiceBanner;
